import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {removeSpaces} from '../../../Shared/directives/common-form-validator.directive';
import {isObjectEmpty, validateAllFormFields} from '../../../Shared/utilities/helpers';
import {NotificationService} from '../../../Shared/services/app-services/notification.service';
import {ActivatedRoute, Router} from '@angular/router';
import {TokenService} from '../../../Shared/services/app-services/token.service';
import {AuthService} from 'src/app/Shared/services/api-services/auth.service';
import {CUSTOM_CONSTANTS} from 'src/app/Shared/utilities/config';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
    public state = {
        post: false,
        formDOM: 'LOGIN',
        passToken: ''
    };

    public loginFormGroup: FormGroup;

    private static loginFormControl = () => {
        return {
            email: ['', [Validators.required, Validators.email, removeSpaces]],
            password: ['', [Validators.required, Validators.minLength(6)]]
            // password: ['']
        };
    };

    constructor(private _FB: FormBuilder, private _activatedRoute: ActivatedRoute , private _router: Router, private _notificationService: NotificationService,
                private _tokenService: TokenService, private _authService: AuthService) {
        this.loginFormGroup = this._FB.group(LoginComponent.loginFormControl());
        // activated route comments
        const paramsData = _activatedRoute.snapshot.queryParams;
        const url = this._activatedRoute.snapshot.url[0].path;
        if (url === 'update-password' && !isObjectEmpty(paramsData)) {
            this.state.passToken = paramsData.up;
            console.log(paramsData);
            this.switchForms('CHANGE_PASSWORD');
        } else {
            _router.navigate(['/login']);
        }
    }

    ngOnInit(): void {
      this._tokenService.logoutToken();
    }

    /**
     *
     * @param form
     */
    public switchForms(form: string): void {
        switch (form) {
            case 'FORGOT_PASSWORD' :
                this.state.formDOM = form;
                break;
            case 'CHANGE_PASSWORD' :
                this.state.formDOM = form;
                break;
            default :
                this.state.formDOM = 'LOGIN';
        }
    }

    public submit(): void {
        if (this.loginFormGroup.invalid) {
            return validateAllFormFields(this.loginFormGroup);
        }
        const payload = this.loginFormGroup.value;
        this.state.post = true;
        // check temporary auth
        this._authService.login(payload).subscribe(res => {
            this.state.post = false;
            console.log(res);
            this._tokenService.setAuthUser(res.data);
            const storedURL = localStorage.getItem('VIEW_DOCUMENT');
            if(storedURL && storedURL.includes('document')) {
              window.location.href = storedURL;
              localStorage.removeItem('VIEW_DOCUMENT');
            } else {
              this._router.navigate(['files/manager']); // redirect
            }
        }, err => {
            console.error('Error ', err);
            this.state.post = false;
            this._notificationService.showError(err.error.message || 'Unable to login');
        });
    }

}
